import * as _ from "lodash";
import { useState } from 'react';
import { Glyphicon, Row } from 'react-bootstrap';
import { ToDoColumnWrapper } from '../styles';
import { IActionCenterToDo } from '@nkr/models/index';
import { ActionItem } from '../models';
import { MainType } from './models/main-type';
import ActionCenterItem from './action-center-item';
import ListType from '../list-type';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    data: IActionCenterToDo,
    showLoading: boolean,
    hideEmptyItems: boolean,
    isAdmin: boolean,
    organType: OrganType,
    onItemClick: (list: ListType[], mainType: MainType, subType: ActionItem) => void
}

const ToDo = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (list: ListType[], subType: ActionItem) => {
        props.onItemClick(list, MainType.ToDo, subType);
    };

    let preSelectsOutstanding = [];
    let stagnantMicrositeUpdates = [];
    let customLogistics = [];
    let pendingRccaps = [];


    if (props.data != null) {
        preSelectsOutstanding = typeof props.data.preselectsOutstanding === 'number' ? _.range(0, props.data.preselectsOutstanding) : props.data.preselectsOutstanding;
        pendingRccaps = typeof props.data.pendingRccaps === 'number' ? _.range(0, props.data.pendingRccaps) : props.data.pendingRccaps;
        stagnantMicrositeUpdates = typeof props.data.stagnantMicrositeUpdates === 'number' ? _.range(0, props.data.stagnantMicrositeUpdates) : props.data.stagnantMicrositeUpdates;

        if (typeof props.data.customLogistics === 'number')
            customLogistics = _.range(0, props.data.customLogistics);
        else if (props.data.customLogistics != null && props.data.customLogistics.length > 0)
            customLogistics = _.range(0, props.data.customLogistics[0].outstanding);
        else
            customLogistics = props.data.customLogistics;
    }

    const matchOffers = props.data != null ? props.data.matchOffers : [];
    const donorClearance = props.data != null ? props.data.donorClearance : [];
    const xmResultsDueToday = props.data != null ? props.data.xmResultsDueToday : [];
    const confirmReimbursementDonations = props.data != null ? props.data.confirmReimbursementDonations : [];
    const missingAdpVoucherHolders = props.data ? props.data.missingVoucherHolders : [];
    const inactiveDonorsInRange = props.data ? props.data.inactiveDonorsInRange : [];
    const donorEvalOutOfDate = props.data ? props.data.donorEvalOutOfDate : [];
    const pendingPatientIntakeReferrals = props.data ? props.data.pendingPatientIntakeReferrals : [];
    const hasAbWaitListPatients = props.data != null && props.data.abWaitListPatients.length > 0 && props.data.abWaitListPatients[0].showHasAbWaitListPatients && props.data.abWaitListPatients[0].hasAbWaitListPatients ? [1] : [];
    const showHasAbWaitListPatients = props.data != null && props.data.abWaitListPatients.length > 0 ? props.data.abWaitListPatients[0].showHasAbWaitListPatients : false;
    const dashToDo = props.data != null ? props.data.dashToDo : [];
    const flaggedForVoucherDonation = props.data != null ? props.data.flaggedForVoucherDonation : [];
    const outstandingInternalDirectSwaps = props.data != null ? props.data.outstandingInternalDirectSwaps : [];
    const missingVoucherConsents = props.data != null ? props.data.missingVoucherConsents : [];
    const atRiskMortalityRecipients = props.data != null ? props.data.mortalityRecipients : []
    const outstandingDonorReimbursements = props.data != null ? props.data.outstandingDonorReimbursements : [];
    const confirmSerologyBloodDraw = props.data != null ? props.data.confirmSerologyBloodDraw : [];
    const confirmBloodDrawCompletion = props.data != null ? props.data.confirmBloodDrawCompletion : [];
    const pendingPatientIntakeTransfers = props.data ? props.data.pendingPatientIntakeTransfers : [];

    const isNkr = props.organType == OrganType.Kidney;

    const items = [
        { name: 'Match Offers', list: matchOffers, actionItem: ActionItem.MatchOffers, show: isNkr },
        { name: 'Donor Clearance', list: donorClearance, actionItem: ActionItem.DonorClearance, show: isNkr },
        { name: 'Pre-Selects', list: preSelectsOutstanding, actionItem: ActionItem.Preselects, show: isNkr },
        { name: 'XM Results', list: xmResultsDueToday, actionItem: ActionItem.XMResults, show: isNkr },
        { name: 'Confirm Donor Reimbursement Eligibility', list: confirmReimbursementDonations, actionItem: ActionItem.ConfirmReimbursementDonations, show: true },
        { name: 'Missing Voucher Holders', list: missingAdpVoucherHolders, actionItem: ActionItem.MissingVoucherHolders, show: isNkr },
        { name: 'Custom Logistics', list: customLogistics, actionItem: ActionItem.CustomLogistics, show: isNkr },
        { name: 'RCCAPs', list: pendingRccaps, actionItem: ActionItem.Rccap, show: true },
        { name: 'Pending Patient Intake Referrals', list: pendingPatientIntakeReferrals, actionItem: ActionItem.PendingPatientIntakeReferrals, show: isNkr },
        { name: 'Stagnant Microsite Updates', list: stagnantMicrositeUpdates, actionItem: ActionItem.StagnantMicrositeUpdates, show: isNkr },
        { name: 'Donation Date Range Conflict', list: inactiveDonorsInRange, actionItem: ActionItem.DonationDateRangeConflict, show: isNkr },
        { name: 'Donor Evals', list: donorEvalOutOfDate, actionItem: ActionItem.DonorEval, show: isNkr },
        { name: 'AB Waitlist Patients', list: hasAbWaitListPatients, actionItem: ActionItem.HasAbWaitListPatients, show: isNkr && showHasAbWaitListPatients },
        { name: 'DASH To-Do', list: dashToDo, actionItem: ActionItem.DashContactDue, show: true },
        { name: 'Flagged for Voucher Donation', list: flaggedForVoucherDonation, actionItem: ActionItem.FlaggedForVoucherDonation, show: isNkr },
        { name: 'Confirm ID Donation/Transplant Occurred', list: outstandingInternalDirectSwaps, actionItem: ActionItem.OutstandingInternalDirectSwaps, show: isNkr },
        { name: 'Missing Voucher Holder Consents', list: missingVoucherConsents, actionItem: ActionItem.MissingVoucherConsents, show: isNkr },
        { name: 'At-Risk Mortality Recipients', list: atRiskMortalityRecipients, actionItem: ActionItem.AtRiskMortalityRecipients, show: isNkr },
        { name: 'Outstanding Donor Reimbursements', list: outstandingDonorReimbursements, actionItem: ActionItem.OutstandingDonorReimbursements, show: true },
        { name: 'Serology: Confirm Draw Date', list: confirmSerologyBloodDraw, actionItem: ActionItem.ConfirmSerologyBloodDraw, show: isNkr },
        { name: 'Serology: Confirm Draw Complete', list: confirmBloodDrawCompletion, actionItem: ActionItem.ConfirmBloodDrawCompletion, show: isNkr },
        //hidden for now
        //{ name: 'Pending Patient Intake Transfers', list: pendingPatientIntakeTransfers, actionItem: ActionItem.PendingPatientIntakeTransfers, show: isNkr },
    ];

    const isEmpty = items.filter(x => x.list.length == 0).length == items.length;
    const itemCount = items.filter(x => x.list.length > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    let title = props.isAdmin ? 'TO-DO - All Centers' : 'TO-DO';

    return (
        <div className='section-urgent' style={{ marginBottom: 20 }}>
            <div className='title-container'>
                <div className={props.isAdmin ? 'title admin-title' : 'title'} onClick={() => setExpanded(!expanded)}>
                    <h4>{title} <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5, color: 'white' }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid var(--red)', width: '85%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ flex: '1 1 auto', backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading to-do items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                if (((!props.hideEmptyItems && item.list.length == 0) || item.list.length > 0) && item.show) {
                                    return (
                                        <ToDoColumnWrapper key={index} className="col-xs-12 col-lg-3">
                                            <ActionCenterItem
                                                description={item.name}
                                                list={item.list}
                                                isList={item.actionItem != ActionItem.HasAbWaitListPatients}
                                                highlight="#c90a0a"
                                                actionItem={item.actionItem}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}

                            {isEmpty && props.hideEmptyItems && (
                                <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                    At this time, there are no urgent items
                                </ToDoColumnWrapper>
                            )}
                        </Row>
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default ToDo;